module.exports = "https://trybtryb-legacy.web.app/img/hanukkah-funukkah.213eac0e.webp";